module.exports = __webpack_public_path__ + "static/img/h2.44375dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h2.jpg
// module id = hokZ
// module chunks = 0